import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";

export default function HvordanTraekkerJeg1000Article() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <h2>1.000 Mbit sikrer dig en god oplevelse</h2>
                        <p>
                            Vi har gjort det til vores mission at stille teknologien til rådighed for dig, så du får friheden til at vælge den hastighed, du har brug for.
                        </p>
                        <p>
                            Hvis du kan få en høj hastighed, f.eks. 1.000 Mbit/s, er der en god grund til at vælge den.
                            Jo hurtigere, jo bedre, hvis du hellere vil bruge tiden på at spille end vente på downloads,
                            have den optimale 4K-oplevelse når du streamer, og elsker når download på din PS5 pisker afsted.
                            Det er dog ikke ensbetydende med, at du altid kan måle 1.000 Mbit/s på en enkelt enhed.
                        </p>
                        <p>
                            Ikke alle enheder på markedet kan trække 1.000 Mbit/s.
                            Bruger du f.eks. en USB3-hub sammen med din PC,
                            er det ikke sikkert at PC&rsquo;en kan trække 1.000 Mbit/s grundet hub&rsquo;ens tekniske begrænsninger.
                            Du skal også være opmærksom på, at ikke alle iPhones/iPads, Android mobiltelefoner eller andre tablets kan trække 1.000 Mbit/s.
                            Der findes kun få mobile enheder på markedet, som kan hente data med 1.000 Mbit/s.
                            Det gælder også streaming-enheder, f.eks. Chromecast og Apple TV.
                        </p>
                    </div>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h2>Dine interne installationer skal understøtte 1.000 Mbit/s</h2>
                        <p>
                            Sørg for at bruge netværkskabler af typen CAT5e/CAT6, som understøtter 1.000 Mbit/s.
                            Bruger du switches og hubs, skal de være Gigabit Ethernet-kompatible.
                        </p>
                        <p>
                            De fysiske materialer i din bolig påvirker dit wifi-signal.
                        </p>
                        <p>
                            Signalstyrken af dit trådløse signal bliver påvirket af, hvor din router står placeret i din bolig.
                            F.eks. virker betonvægge, termoruder med indbygget solafskærmning samt konstruktionsjern i vægge og gulve dæmpende på signalet.
                        </p>
                        <p>
                            Herudover afhænger signalstyrken af afstanden mellem routeren, du har modtaget fra os, og din enhed, som bruger internettet.
                            Det betyder, at du typisk vil opleve et fald i hastigheden, hvis du går længere væk fra routeren.
                            Nogle gange vil det være mærkbart, mens det andre gange ikke er noget du vil lægge mærke til ved normal internetbrug.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er min fordel ved at vælge 1.000 Mbit<span className="thin-slash">/</span>s?</h2>
                        <p>
                            Under de rette omstændigheder er der store fordele ved 1.000 Mbit/s &ndash; både på netværkskabel og wifi.
                            I dag er det nemlig almindeligt i danske hjem, at mange enheder bruger internettet samtidig.
                        </p>
                        <p>
                            Nogle af vores kunder har over 30 enheder på internettet samtidig &ndash;
                            PC&rsquo;er, tablets, smartphones, Smart TV, særskilte TV/video-enheder (f.eks. Apple TV og Chromecast),
                            spillekonsoller (Xbox, PlayStation), NAS-systemer (til lagring af film og billeder), musik-anlæg (f.eks. Sonos), osv.
                            Og her er 1.000 Mbit/s en stor fordel.
                        </p>
                        <p>
                            Hvis du bor i et hjem med mange enheder på internettet &ndash; og I er flere online samtidig &ndash; er 1.000 Mbit/s optimalt.
                            En samlet hastighed på 1.000 Mbit/s betyder nemlig, at de mange enheder i dit hjem kører uden problemer samtidigt, selv om alle bruger båndbredde på samme tid.
                        </p>
                        <p>
                            <strong>Kort sagt:</strong> Med den hurtigste forbindelse er du sikker på, at der altid er net nok til alle!
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "hastighedstest",
                        "name": "Hastighedstest"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "netvaerkskanaler",
                        "name": "Netværkskanaler"
                    }
                ]}
            />
        </>
    )
}
